import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const BackgroundVideo = () => {
  const [opacity, setOpacity] = useState(0);
  const currentPage = useSelector(state => state.pageReducer);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOpacity(0); // Reset opacity when page changes, this is intentional and can ignore linter here
    let flickerInterval;
    let flickerTimeout;
    let mainTimer;

    const startFlickering = () => {
      // Random flicker duration between 0.5 and 2 seconds
      const flickerDuration = Math.random() * 1500 + 500;

      // Start flickering
      flickerInterval = setInterval(() => {
        const randomOpacity = Math.random() * 0.25 + 0.1; // 0.1 to 0.35 opacity
        setOpacity(randomOpacity);
      }, 50); // Flicker every 50ms during the burst

      // Stop flickering after the random duration
      flickerTimeout = setTimeout(() => {
        clearInterval(flickerInterval);
        setOpacity(0); // Return to 0 opacity

        // Schedule the next flicker after this one completes
        scheduleNextFlicker();
      }, flickerDuration);
    };

    const scheduleNextFlicker = () => {
      // Adjust timing based on current page
      let nextDelay;

      if (currentPage === "Home") {
        // Home page: more frequent flickering
        nextDelay = Math.random() * 800 + 200; // 0.2 to 1 secs
      } else if (currentPage === "Contact") {
        // Contact page: somewhat frequent flickering
        nextDelay = Math.random() * 800 + 1000; // 1 to 1.8 secs
      } else {
        // Other pages: less frequent flickering
        nextDelay = Math.random() * 3000 + 5000; // 5 to 8 secs
      }

      mainTimer = setTimeout(() => {
        startFlickering();
      }, nextDelay);
    };

    // Start the first flicker cycle
    scheduleNextFlicker();

    return () => {
      // Clean up ALL timers when component unmounts or page changes
      clearInterval(flickerInterval);
      clearTimeout(flickerTimeout);
      clearTimeout(mainTimer);
    };
  }, [currentPage]); // Re-run effect when page changes

  const videoRef = useRef();
  const setPlayBack = () => {
    videoRef.current.playbackRate = 0.6;
  };

  return (
    <div className="background-video-container">
      <video
        className="background-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        ref={videoRef}
        onCanPlay={() => setPlayBack()}
        style={{
          opacity: opacity,
        }}
      >
        <source src="/assets/videos/tech-glitches.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default BackgroundVideo;
